import { mutator } from 'satcheljs';
import {
    updateChildOptionIsShown,
    updateParentOptionIsExpanded,
} from '../actions/parentOptionIsExpandedActions';

mutator(updateParentOptionIsExpanded, actionMessage => {
    const { parentOption, parentIsExpanded } = actionMessage;

    parentOption.isExpanded = parentIsExpanded;
});

mutator(updateChildOptionIsShown, actionMessage => {
    const { pickerOption, optionIsShown } = actionMessage;

    pickerOption.isShown = optionIsShown;
});
